module.exports = __webpack_public_path__ + "static/media/morning.609ba878.png";